/*
Sprint 34 - Remover no futuro
Contador para controlar o modal, para habilitar ou desabilitar
*/
import { HttpService } from "./http.service"; // Importa o serviço HTTP para requisições

// Defina o caminho base para as requisições relacionadas ao ConfigFeature
const basePath = "/ConfigFeature"; 
const request = HttpService.handleRequest();

// Exporta os métodos do serviço
export const ConfigFeatureService = {
  getFeatureCount,
  // Você pode adicionar outros métodos conforme necessário
};

// Método para obter a contagem de registros com base nos critérios especificados
async function getFeatureCount(featureId, codeType, refId) {
  try {
    // Faz uma requisição GET para o endpoint "count" com os parâmetros especificados
    const response = await request.get(`${basePath}/count`, {
      params: { featureId, codeType, refId },
    });

    // Verifica se o response existe e retorna a contagem, ou 0 caso não exista
    //console.log("response existe: " + JSON.stringify(response));
    return response ?? 0;
  } catch (error) {
    console.error("Erro ao obter a contagem de ConfigFeature:", error);
    return 0; // Retorna 0 em caso de erro
  }
}
